export default __webpack_public_path__ + "static/google-cloud-fefb9da3ee2e03a41d4952f829b0f444.svg";